import { render, staticRenderFns } from "./ComplexEyes.vue?vue&type=template&id=2cb6e238"
import script from "./ComplexEyes.vue?vue&type=script&lang=js"
export * from "./ComplexEyes.vue?vue&type=script&lang=js"
import style0 from "./ComplexEyes.vue?vue&type=style&index=0&id=2cb6e238&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports